import { CURRENCY } from 'src/types';

export enum MONEY_ACCOUNT_TYPE {
    CASH = 'cash',
    BANK = 'bank',
    PROCESSOR = 'processor',
}

export type MoneyAccount = {
    id: string;
    created_at: string;
    modified_at: string;
    name: string;
    type: MONEY_ACCOUNT_TYPE;
    reference: string;
    currency: CURRENCY;
    is_active: boolean;
    iban: string | null;
    tenant: string | null;
    billing_entity: {
        id: string;
        name: string;
    };
};
